import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CompanySelectionModal from './CompanySelectionModal';
import { useAuth } from '../../context/AuthContext';
import { setSelectedCompany } from '../../store/slices/companySlice';
import Layout from '../Layout';

const CompanyGuard = ({ children }) => {
  const { user } = useAuth();
  const selectedCompany = useSelector((state) => state.company.selectedCompany);
  const dispatch = useDispatch();
  const userConsent = localStorage.getItem('userConsent') === 'true';
  const isVendorAssessmentPage =
    window.location.pathname === '/vendor-assessment';
  const needsCompany =
    !isVendorAssessmentPage &&
    (user?.role === 'security_analyst' || user?.role === 'auditor') &&
    !selectedCompany;

  // Remember the last selected company so the modal can highlight it
  // even when selectedCompany has been cleared to trigger switching
  const previousCompanyRef = useRef(null);
  useEffect(() => {
    if (selectedCompany) {
      previousCompanyRef.current = selectedCompany;
    }
  }, [selectedCompany]);

  const handleSelect = (company) => {
    dispatch(setSelectedCompany(company));
  };

  return (
    <>
      {needsCompany && userConsent ? (
        <Layout>
          <CompanySelectionModal
            isOpen={true}
            onSelect={handleSelect}
            previousCompany={previousCompanyRef.current}
            required
          />
        </Layout>
      ) : children}
    </>
  );
};

export default CompanyGuard;
